export default __webpack_public_path__ + "static/media/premium_normal-available_loan.a1f91275.jpg";